module.exports = __webpack_public_path__ + "img/pencilplus.3f78732e.png";